import clsx from 'clsx';
import styles from './DescriptionList.module.scss';

type DescriptionListAllowedChildren = React.ReactElement<
  React.ComponentProps<typeof DescriptionListItem>
>;

interface DescriptionListProps {
  children:
    | DescriptionListAllowedChildren
    | DescriptionListAllowedChildren[]
    | (DescriptionListAllowedChildren | DescriptionListAllowedChildren[])[];
  ariaBusy?: boolean;
  variant?: 'default' | 'equal-width' | 'separated';
}

export const DescriptionList: React.FC<DescriptionListProps> = ({
  children,
  ariaBusy,
  variant = 'default',
}) => (
  <dl
    className={clsx(styles.list, {
      [styles.listDefault]: variant === 'default',
      [styles.listEqualWidth]: variant === 'equal-width',
      [styles.listSeparated]: variant === 'separated',
    })}
    aria-busy={ariaBusy}
  >
    {children}
  </dl>
);

interface DescriptionListItemProps {
  term: string;
  children: React.ReactNode;
}

export const DescriptionListItem: React.FC<DescriptionListItemProps> = ({ term, children }) => (
  <>
    <dt className={styles.term}>{term}</dt>
    <dd className={styles.details}>{children}</dd>
  </>
);
